import {
  LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE,
  CREATE_REQUEST, CREATE_SUCCESS, CREATE_FAILURE,
  UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE,
  DELETE_REQUEST, DELETE_SUCCESS, DELETE_FAILURE,
  TEST_REQUEST, TEST_SUCCESS, TEST_FAILURE,
  SCHEMA_REQUEST, SCHEMA_SUCCESS, SCHEMA_FAILURE,
  GET_REQUEST, GET_SUCCESS, GET_FAILURE,
  CLEAR, CLEAR_TEST_RESULT
} from '../../actions/ingestion/sources';

const initialState = {
  // List state
  sources: [],
  isLoading: false,
  error: null,
  
  // Create state
  isCreating: false,
  createError: null,
  createdSource: null,
  
  // Update state
  isUpdating: false,
  updateError: null,
  updatedSource: null,
  
  // Delete state
  isDeleting: false,
  deleteError: null,
  deletedSourceId: null,
  
  // Test connection state
  isTesting: false,
  testError: null,
  testResults: {},
  
  // Schema state
  isLoadingSchema: false,
  schemaError: null,
  schemas: {},
  
  // Single source state
  currentSource: null,
  currentSourceStatistics: null,
  isLoadingSource: false,
  sourceError: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    // List sources
    case LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    
    case LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sources: action.payload.sources || action.payload,
        error: null
      };
    
    case LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    
    // Create source
    case CREATE_REQUEST:
      return {
        ...state,
        isCreating: true,
        createError: null,
        createdSource: null
      };
    
    case CREATE_SUCCESS:
      return {
        ...state,
        isCreating: false,
        createdSource: action.payload,
        createError: null,
        // Add to sources list if it exists
        sources: state.sources ? [...state.sources, action.payload] : state.sources
      };
    
    case CREATE_FAILURE:
      return {
        ...state,
        isCreating: false,
        createError: action.payload
      };
    
    // Update source
    case UPDATE_REQUEST:
      return {
        ...state,
        isUpdating: true,
        updateError: null,
        updatedSource: null
      };
    
    case UPDATE_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        updatedSource: action.payload,
        updateError: null,
        // Update in sources list if it exists
        sources: state.sources ? state.sources.map(source => 
          source.source_id === action.payload.source_id ? action.payload : source
        ) : state.sources
      };
    
    case UPDATE_FAILURE:
      return {
        ...state,
        isUpdating: false,
        updateError: action.payload
      };
    
    // Delete source
    case DELETE_REQUEST:
      return {
        ...state,
        isDeleting: true,
        deleteError: null,
        deletedSourceId: null
      };
    
    case DELETE_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        deletedSourceId: action.payload.sourceId,
        deleteError: null,
        // Remove from sources list if it exists
        sources: state.sources ? state.sources.filter(source => 
          source.source_id !== action.payload.sourceId
        ) : state.sources
      };
    
    case DELETE_FAILURE:
      return {
        ...state,
        isDeleting: false,
        deleteError: action.payload
      };
    
    // Test connection
    case TEST_REQUEST:
      return {
        ...state,
        isTesting: true,
        testError: null,
        testResults: {
          ...state.testResults,
          [action.payload.sourceId]: { status: 'testing' }
        }
      };
    
    case TEST_SUCCESS:
      return {
        ...state,
        isTesting: false,
        testError: null,
        testResults: {
          ...state.testResults,
          [action.payload.sourceId]: {
            status: 'success',
            message: action.payload.message,
            timestamp: new Date().toISOString()
          }
        }
      };
    
    case TEST_FAILURE:
      return {
        ...state,
        isTesting: false,
        testError: action.payload,
        testResults: {
          ...state.testResults,
          [action.payload.sourceId]: {
            status: 'failed',
            error: action.payload.error || action.payload.message,
            timestamp: new Date().toISOString()
          }
        }
      };
    
    // Get schema
    case SCHEMA_REQUEST:
      return {
        ...state,
        isLoadingSchema: true,
        schemaError: null
      };
    
    case SCHEMA_SUCCESS:
      return {
        ...state,
        isLoadingSchema: false,
        schemaError: null,
        schemas: {
          ...state.schemas,
          [action.payload.sourceId]: action.payload.schema
        }
      };
    
    case SCHEMA_FAILURE:
      return {
        ...state,
        isLoadingSchema: false,
        schemaError: action.payload
      };
    
    // Get single source
    case GET_REQUEST:
      return {
        ...state,
        isLoadingSource: true,
        sourceError: null
      };
    
    case GET_SUCCESS:
      const sourceData = action.payload.source || action.payload;
      const statistics = action.payload.statistics || null;
      
      return {
        ...state,
        isLoadingSource: false,
        currentSource: sourceData,
        currentSourceStatistics: statistics,
        sourceError: null,
        // Also update in sources list if it exists
        sources: state.sources.map(source => 
          source.source_id === sourceData.source_id ? sourceData : source
        )
      };
    
    case GET_FAILURE:
      return {
        ...state,
        isLoadingSource: false,
        sourceError: action.payload
      };
    
    // Clear state
    case CLEAR:
      return initialState;
    
    case CLEAR_TEST_RESULT:
      const { [action.payload.sourceId]: removed, ...remainingTestResults } = state.testResults || {};
      return {
        ...state,
        testResults: remainingTestResults
      };
    
    default:
      return state;
  }
};
